// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  SessionRole,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  sessionId: __t.u64().name("session_id"),
  userIdentity: __t.identity().name("user_identity"),
  presenceId: __t.u64().name("presence_id"),
  get role() {
    return SessionRole;
  },
  isActive: __t.bool().name("is_active"),
  joinedAt: __t.timestamp().name("joined_at"),
});
